<template>
    <div :class="'mb-3 ' + computed_col">
        <div class="card">
            <div class="card-body p-3">
                <div class="d-flex justify-content-between align-items-center">
                    <h2 class="m-0 pr-2">{{number}}</h2>
                    <div class="w-100">
                        <div class="progress">
                            <div :class="'progress-bar ' + computed_color" role="progressbar" style="width: 25%" 
                                aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
                            </div>
                        </div>
                    </div>
                </div>
                <p class="m-0">{{title}}</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: [
        'col',
        'title',
        'number',
        'color',
    ],
    computed: {
        computed_col() {
            if(this.col == undefined) {
                return 'col-xs-12 col-sm-6 col-lg-4';
            } else if(this.col == 'auto') {
                return 'col';
            } else if(this.col == 'false') {
                return '';
            } else {
                this.col;
            }
        },
        computed_color() {
            if(this.color == undefined) {
                return 'bg-primary';
            } else {
                return 'bg-'+this.color;
            }
        }
    }
}
</script>